import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import styled from "styled-components";

const Table24 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [onEditCurrent, setOnEditCurrent] = useState(
    props.type === "edit" ? false : true
  );
  const [PowerbiData, setPowerbiData] = useState(null);
  const [previousData, setPreviousData] = useState(null);
  const [importPath, setImportPath] = useState(null);
  const [attributeList, setAttribute] = useState(null);
  const [pillarList, setPillar] = useState(null);
  const [seriesList, setSeries] = useState(null);
  const [seriestypeList, setSeriestype] = useState(null);
  const [seriesunitsList, setSeriesunits] = useState(null);
  const [subpillarList, setSubpillar] = useState(null);
  const [subsubpillarList, setSubsubpillar] = useState(null);

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = () => {
    const obj = [];
    PowerbiData.map((item, index) => {
      const data = { ...item };
      data.yearId = props.yearId;
      delete data.id;
      delete data.createDate;
      delete data.lastUpdate;
      delete data.tableHeadId;
      delete data.id;
      obj.push(data);
    });
    const filter = obj.filter((item) => item.fillValue === "");
    console.log("@PowerbiData", filter);
    if (filter.length > 0) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return false;
    }
    props.onCeateTable(obj);
  };

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ?  null  : Number(props.yearNo)
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        
        if (response.data.data.length > 0) {
          setImportPath(response.data.data[0].importPath);
          if(response.data.data[0].list.length == 0){
            getNewData();
          }
          else{
            const dataView = response.data.data[0].list.map((item) => {
              let data = { ...item };
              if (props.type === "new" && props.newHeadId){
                if(response.data.data[0].yearId !=  props.yearId){
                data.fillValue = "";
                data.growth = "";
                }
              }
              return data;
            });setLoading(false);
            setPowerbiData(dataView);
          }
        } else {setLoading(false);
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getNewData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          const dataView = response.data.data[0].list.map((item) => {
            let data = { ...item };
              data.fillValue = "";
              data.growth = "";
            return data;
          });
          setPowerbiData(dataView);
        } else {
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getPreviousData = () => {
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId,
        status: 1,
        yearNo: Number(props.yearNo) - 1,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        console.log(`getPreviousData ${props.yearsName}`, response.data);
        if (response.data.data.length > 0) {
          const viewData = response.data.data[0].list.map((item, key) => {
            return {
              typeId: item.typeId,
              typeName: item.typeName,
              unitId: item.unitId,
              unitName: item.unitName,
              fillValue: item.fillValue,
            };
          });
          setPreviousData(viewData);
          console.log("setPreviousData", previousData);
        } else {
          setPreviousData(null);
        }
      })
      .catch(function(error) {
        console.log(
          `/v1/setting-table/listhead/yearNo=${props.yearNo}`,
          error
        );
      });
  };

  const getAttribute = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table24/table24attribute`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        console.log("Attribute", response.data);
        setAttribute(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table24/table24attribute", error);
      });
  };

  const getPillar = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table24/table24pillar`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setPillar(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table24/table24pillar", error);
      });
  };

  const getSeries = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table24/table24series`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSeries(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table24/table24series", error);
      });
  };

  const getSeriestype = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table24/table24seriestype`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSeriestype(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table24/table24seriestype", error);
      });
  };

  const getSeriesunits = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table24/table24seriesunits`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSeriesunits(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table24/table24seriesunits", error);
      });
  };

  const getSubpillar = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table24/table24subpillar`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSubpillar(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table24/table24subpillar", error);
      });
  };

  const getSubsubpillar = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table24/table24subsubpillar`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSubsubpillar(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table24/table24subsubpillar", error);
      });
  };

  useEffect(() => {
    getAttribute();
    getPillar();
    getSeries();
    getSeriestype();
    getSeriesunits();
    getSubpillar();
    getSubsubpillar();

    getCurrentData();
  }, []);
  
  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  const onAddRowTable = () => {
    let datas = [...PowerbiData];
    const data = {...datas[0]};
    data.fillValue = "";
    data.growth = "";
    setPowerbiData(datas.concat([data]));
  };

  const onSetdataCost = (index, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index].fillValue = value;
    setPowerbiData(newTodos);
  };

  const onSetdata = (index, dataName, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index][dataName] = value;
    setPowerbiData(newTodos);
  };

  const calRatio = (index, value) => {
    if (previousData == null || previousData[index] == undefined) {
      return Number(value).toFixed(2);
    } else {
      return ((Number(value) / previousData[index].value) * 100).toFixed(8);
    }
  };

  const calGrowth = (index, value) => {
    if (previousData == null || previousData[index] == undefined) {
      return Number(value).toFixed(2);
    } else {
      return (
        ((Number(value) - previousData[index].value) /
          previousData[index].value) *
        100
      ).toFixed(8);
    }
  };

  return (
    <Row>
      {props.type === "edit" ? (
        <Col md="12" style={{ padding: "15px" }}>
          <h5 style={{ float: "left" }}>
            จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
            แถว เนื่องจากข้อมูลมีจำนวนมากจึงไม่สามารถแสดงได้
          </h5>
        </Col>
      ) : (
        <Col md="12" style={{ padding: "15px" }}>
          <h3>
            เนื่องจากชุดข้อมูล มีข้อมูลจำนวนมาก กรุณาเพิ่มข้อมูลต่างๆในรูปแบบ
            UPLOAD FILE
          </h3>
        </Col>
      )}

      {props.tableTabMaster
        ? null
        : props.type === "edit" && (
            <Col md="12" style={{ padding: "15px" }}>
              {props.status == 0 && props.userType != 3 ? (
                <>
                {importPath != null && (
                  <a href={importPath} download >
                    <Button theme="warning" style={{ float: "left" }}>
                      ดาวน์โหลดไฟล์ข้อมูลที่ใช้นำเข้า
                    </Button>
                  </a>
                )}

                <Button
                  theme="success"
                  onClick={() => props.onApproveTable()}
                  style={{ float: "right", width: 200 }}
                >
                  อนุมัติเผยแพร่
                </Button>
              </>
              ) : null}
            </Col>
          )}
    </Row>
  );
};

export default Table24;
